/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MemoryEntryDeleted = {
  id: string;
  object: "memory_entry.deleted";
  deleted: boolean;
};

/** @internal */
export const MemoryEntryDeleted$inboundSchema: z.ZodType<
  MemoryEntryDeleted,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  object: z.literal("memory_entry.deleted"),
  deleted: z.boolean(),
});
/** @internal */
export type MemoryEntryDeleted$Outbound = {
  id: string;
  object: "memory_entry.deleted";
  deleted: boolean;
};

/** @internal */
export const MemoryEntryDeleted$outboundSchema: z.ZodType<
  MemoryEntryDeleted$Outbound,
  z.ZodTypeDef,
  MemoryEntryDeleted
> = z.object({
  id: z.string(),
  object: z.literal("memory_entry.deleted"),
  deleted: z.boolean(),
});

export function memoryEntryDeletedToJSON(
  memoryEntryDeleted: MemoryEntryDeleted,
): string {
  return JSON.stringify(
    MemoryEntryDeleted$outboundSchema.parse(memoryEntryDeleted),
  );
}
export function memoryEntryDeletedFromJSON(
  jsonString: string,
): SafeParseResult<MemoryEntryDeleted, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MemoryEntryDeleted$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MemoryEntryDeleted' from JSON`,
  );
}
